<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <interes-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import InteresShowData from "./InteresShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "InteresShow",
        components: {CrudShow, InteresShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.interes.showing',
            }
        },
    }
</script>

